module.exports = __webpack_public_path__ + "static/media/about-julia-image.fc343474.jpg";